// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3hJDh","loaderOuter":"PageOverlayLoader_loaderOuter__2Z5T7"};